export const VACANCY_ACTION_PERMISSIONS = {
  DELETE: 'change_vacancy_active',
  HARD_DELETE: 'delete_vacancy',
  DEACTIVATE: 'change_vacancy_broadcast',
  ACCEPT_MODERATION: 'accept_moderation',
  SEND_TO_MODERATION: 'renew_moderation',
  VIEW_HISTORY: 'view_vacancy_history',
};
